import { render, staticRenderFns } from "./KorrFormatFilter.vue?vue&type=template&id=307e63f8&"
import script from "./KorrFormatFilter.vue?vue&type=script&lang=js&"
export * from "./KorrFormatFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports